var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "16px",
    viewBox: "0 0 11 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.8825,2.34701 C0.8825,1.42174 1.63089,0.67 2.55482,0.67 L8.59018,0.67 C9.51478,0.67 10.2625,1.4204 10.2625,2.34701 L10.2625,13.73299 C10.2625,14.65826 9.51411,15.41 8.59018,15.41 L2.55482,15.41 C1.63022,15.41 0.8825,14.6596 0.8825,13.73299 L0.8825,2.34701 Z M2.2225,2.34701 L2.2225,13.73299 C2.2225,13.92059 2.37124,14.07 2.55482,14.07 L8.59018,14.07 C8.77242,14.07 8.9225,13.91925 8.9225,13.73299 L8.9225,2.34701 C8.9225,2.15941 8.77376,2.01 8.59018,2.01 L2.55482,2.01 C2.37258,2.01 2.2225,2.16075 2.2225,2.34701 Z M5.5725,13.4 C5.01774,13.4 4.5675,12.94976 4.5675,12.395 C4.5675,11.84024 5.01774,11.39 5.5725,11.39 C6.12726,11.39 6.5775,11.84024 6.5775,12.395 C6.5775,12.94976 6.12726,13.4 5.5725,13.4 Z M4.9025,4.02 C4.53266,4.02 4.2325,3.71984 4.2325,3.35 C4.2325,2.98016 4.53266,2.68 4.9025,2.68 L6.2425,2.68 C6.61234,2.68 6.9125,2.98016 6.9125,3.35 C6.9125,3.71984 6.61234,4.02 6.2425,4.02 L4.9025,4.02 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "04-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.2-\\u2014-Profile",
    transform: "translate(-1083.000000, -644.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone-No",
    transform: "translate(1074.000000, 640.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16x16/Phone",
    transform: "translate(9.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#3A464F",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/Phone_Icon.36941f9cffba43f55cfa1bbac909b335.svg";
export { ForwardRef as ReactComponent };